/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of entity associated with the event
 * @export
 */
export const EntityType = {
    Claim: 'claim',
    Task: 'task',
    Document: 'document',
    Comparison: 'comparison',
    Supplement: 'supplement',
    Note: 'note',
    User: 'user',
    Email: 'email',
    System: 'system'
} as const;
export type EntityType = typeof EntityType[keyof typeof EntityType];


export function instanceOfEntityType(value: any): boolean {
    for (const key in EntityType) {
        if (Object.prototype.hasOwnProperty.call(EntityType, key)) {
            if (EntityType[key as keyof typeof EntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntityTypeFromJSON(json: any): EntityType {
    return EntityTypeFromJSONTyped(json, false);
}

export function EntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityType {
    return json as EntityType;
}

export function EntityTypeToJSON(value?: EntityType | null): any {
    return value as any;
}

export function EntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EntityType {
    return value as EntityType;
}

